import React from 'react'


function HowToCut() {
  return (
    <>
    <div className="display-6 text-center mt-3">Kako sjeći visoku tortu</div>
    <div className="text-center">
        <p>Ovaj informativni video pruža brze i jednostavne savjete o pravilnom rezanju torte,
        <br/> otkrivajući tehnike koje će vam pomoći da svaki rez bude savršen.</p>
    <iframe width="auto" height="560" src="https://www.youtube.com/embed/RtkQZwz4BGc?si=LosDMCpT8ug9XCxp" title="Kako sjeći tortu" frameborder="2" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    
    </>
  )
}

export default HowToCut